import { render, staticRenderFns } from "./OrderSimCardsWidget.vue?vue&type=template&id=fc2beca2&scoped=true"
import script from "./OrderSimCardsWidget.vue?vue&type=script&lang=ts"
export * from "./OrderSimCardsWidget.vue?vue&type=script&lang=ts"
import style0 from "./OrderSimCardsWidget.vue?vue&type=style&index=0&id=fc2beca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2beca2",
  null
  
)

export default component.exports